import Cookie from 'js-cookie'

const hasBug = (): boolean => {
  const key = 'test-' + Math.random() * 100000
  const value = String(Math.random)
  localStorage.setItem(key, value)
  const result = localStorage.getItem(key)
  localStorage.removeItem(key)
  return value !== result
}

if (hasBug()) {
  console.warn('local storage bugged, readonly for now')
}

const PREFIX = 'combined-storage-'

class CombinedStorage {
  /**
   * @param key
   * @returns {string|undefined}
   */
  getItem(key: string): string | undefined {
    const fromCookie = Cookie.get(PREFIX + key)
    const fromLocalStorage = localStorage.getItem(key)
    return fromCookie ?? (fromLocalStorage ?? undefined)
  }

  /**
   * @param key
   * @param value
   */
  setItem(key: string, value: string): void {
    Cookie.set(PREFIX + key, value)
    localStorage.setItem(key, value)
  }

  /**
   * @param key
   */
  removeItem(key: string): void {
    Cookie.remove(PREFIX + key)
    localStorage.removeItem(key)
  }
}

export const combinedStorage = new CombinedStorage()
